var handlePositiveKeyDown = function handlePositiveKeyDown(e, eventHandler) {
  if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
    e.preventDefault();
    eventHandler();
  }
};

export { handlePositiveKeyDown };
